module.exports = __webpack_public_path__ + "img/mono-rounded.ca38b531.svg";